import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, CardTitle, InputGroup, Label, FormGroup, Button } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import { connect } from "react-redux"
import * as url from "../../helpers/url_helper"
import { setBreadcrumbItems } from "../../store/actions"
import moment from "moment"
import { BarLoader } from "react-spinners"

const typeOptions = [
  { label: "Tout", value: "" },
  { label: "Colis", value: "DEFAULT" },
  { label: "Bagage", value: "BAGAGE" },
]

const AgenceReport = (props) => {
  document.title = "Rapport par agence | Rapports"

  const userJson = JSON.parse(localStorage.getItem("user"))
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"))
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"))
  const [selectedType, setSelectedType] = useState(typeOptions[0])
  const [agences, setAgences] = useState([])
  const [selectedAgence, setSelectedAgence] = useState(null)

  const loadAgences = () => {
    fetch(`${url.BACKEND_URL}/agence?etp=${userJson.usAgence.agEtp.etpId}&size=100`, {
      method: "GET", headers: { Accept: "application/json", "Content-Type": "application/json" }
    })
      .then(res => res.json())
      .then(json => {
        if (json.status == 200) {
          setAgences(json.data.map(item => ({ label: item.agNom, value: item.agId })))
        }
      })
      .catch(() => {})
  }

  const loadReport = () => {
    setLoading(true)
    const agenceParam = selectedAgence ? `&agence=${selectedAgence.value}` : ""
    const typeParam = selectedType.value ? `&type=${selectedType.value}` : ""
    const reqUrl = `${url.HISTORY_URL}/transaction/agence-report?start=${startDate}&end=${endDate}&etp=${userJson.usAgence.agEtp.etpId}&deleted=0${agenceParam}${typeParam}`
    console.log("agence-report request", reqUrl)
    fetch(reqUrl, {
      method: "GET", headers: { Accept: "application/json", "Content-Type": "application/json" }
    })
      .then(res => res.json())
      .then(json => {
        console.log("agence-report", json)
        if (json.status == 200) { setData(json.data) }
        setLoading(false)
      })
      .catch(() => { setLoading(false) })
  }

  useEffect(() => {
    props.setBreadcrumbItems("Rapport par agence")
    loadAgences()
    loadReport()
  }, [])

  return (
    <React.Fragment>
      <Row>
        <Col xl="2">
          <FormGroup className="mb-4">
            <Label>Début</Label>
            <InputGroup>
              <Flatpickr className="form-control d-block" placeholder="Date début" value={startDate}
                onChange={date => setStartDate(moment(date[0]).format("YYYY-MM-DD"))}
                options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }} />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xl="2">
          <FormGroup className="mb-4">
            <Label>Fin</Label>
            <InputGroup>
              <Flatpickr className="form-control d-block" placeholder="Date fin" value={endDate}
                onChange={date => setEndDate(moment(date[0]).format("YYYY-MM-DD"))}
                options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }} />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Agence</Label>
            <Select
              value={selectedAgence}
              onChange={setSelectedAgence}
              options={agences}
              placeholder="Toutes les agences"
              isClearable
              classNamePrefix="select2-selection"
            />
          </FormGroup>
        </Col>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Type</Label>
            <Select
              value={selectedType}
              onChange={setSelectedType}
              options={typeOptions}
              classNamePrefix="select2-selection"
            />
          </FormGroup>
        </Col>
        <Col xl="2">
          <div className="mt-4">
            <Button type="button" style={{ width: "100%" }} onClick={loadReport} color="primary" size="lg" className="mt-1 waves-effect waves-light">
              Rechercher
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="h4">{data.length} résultat(s)</CardTitle>
              <div className="table-rep-plugin">
                <div className="table-responsive mb-0" data-pattern="priority-columns">
                  <div>{loading ? <BarLoader width="100%" height={6} /> : null}</div>
                  <Table id="agence-report-table" className="table table-striped table-bordered" style={{ fontSize: 11 }}>
                    <Thead>
                      <Tr>
                        <Th>Agence</Th>
                        <Th>Nbre opérations</Th>
                        <Th>Valeur totale (FCFA)</Th>
                        <Th>Frais totaux (FCFA)</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {data.map((item, key) => (
                        <Tr key={key}>
                          <Th><strong>{item.agNom}</strong></Th>
                          <Td>{item.cpt}</Td>
                          <Td>{item.sumValue?.toLocaleString("fr-FR")}</Td>
                          <Td><strong>{item.sumFrais?.toLocaleString("fr-FR")}</strong></Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(AgenceReport)
